
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"13"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M4.127.496C4.51-.12 5.37.356 5.16 1.07L3.89 5.14h2.33c.483 0 .757.616.464 1.044l-4.338 6.34c-.407.595-1.244.082-1.01-.618l1.384-4.25H.778c-.47 0-.748-.59-.48-1.02L4.13.495z","fill":"#F6A623"}}),_c('path',{attrs:{"fill":"#FEF79E","d":"M4.606.867L.778 7.007h2.807l-1.7 5.126 4.337-6.34H3.16"}})])])
          )
        }
      }
    